import { connection } from '@/api/connection'

export default {
  getUrl () {
    return connection.get('quicksight/url')
  }
}
